<template>
    <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    DAFTAR PASIEN PULANG RAWAT INAP
                </h1>
                <!-- <p class="font-sm text-center mt-2">
                    SEMUA REGISTER AKTIF
                </p>
                <p class="font-sm text-center mt-2">
                    TANGGAL JAM {{ pasienPulangRanap.tglJam }}
                </p> -->
                <p class="font-sm text-center mt-2 font-bold">
                    TOTAL PASIEN PROSES PULANG {{ pasienPulangRanap.pasienProsesPulang }}
                </p>
            </div>
            <div class="w-full md:w-1/2 mt-5 mx-auto">
                <SelectInput
                            v-model="statusData"
                            id="status"
                            label="STATUS"
                        >
                            <option value="">=== PILIH STATUS ===</option>
                            <option value="all">Semua</option>
                            <option value="active">Aktif</option>
                            <option value="out">Keluar</option>
                            <option value="void">Void</option>
                </SelectInput>
            </div>
            <div class="w-full md:w-1/2 mt-5 mb-5 mx-auto">
                <DateInput
                    v-model="tglMasukBedData"
                    class="w-full grow mr-5"
                    id="tgl_masuk"
                    label="PILIH TANGGAL MASUK BED"
                />
            </div>
            <div class="w-full flex md:w-1/2 mx-auto">
                <button
                    @click.prevent="getPasienPulangRanap()"
                    class="bg-green-600 hover:bg-green-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center w-36 h-10 text-xs"
                >
                    CARI
                </button>
            </div>
            <div class="w-full my-3">
                <div class="font-poppins mt-2 mb-2 text-right">
                    <p class="font-sm">
                        data diperbaharui pada :
                        <span class="text-red-500"
                            >{{ timerCount }}</span
                        >
                    </p>
                </div>
                <div class="w-full">
                    <div v-for="pasienPulangRanap in pasienPulangRanapData" class="w-full bg-white rounded-md shadow p-2 mb-5">
                        <div class="w-1/2 mx-auto bg-white rounded-md shadow overflow-x-auto scrollbar-track-black mb-3 mt-2">
                            <table class="w-full whitespace-nowrap">
                                <tr class="text-left font-bold bg-amber-100">
                                    <td class="py-2 px-3 text-center text-sm">RUANG</td>
                                    <td class="py-2 px-3 text-center text-sm">{{pasienPulangRanap.ruang}}</td>
                                </tr>
                                <tr class="hover:bg-gray-100">
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">BED TERISI</td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">{{pasienPulangRanap.bedTerisi}}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300">
                            <table class="w-full whitespace-nowrap">
                                <thead>
                                    <tr class="text-left font-bold bg-amber-100">
                                        <th class="py-2 px-3 text-center text-sm">
                                            No
                                        </th>
                                        <th class="py-2 px-3 text-center text-sm">
                                            Nama BED
                                        </th>
                                        <th class="py-2 px-3 text-center text-sm">
                                            Nama Pasien
                                        </th>
                                        <th class="py-2 px-3 text-center text-sm">
                                            Alamat
                                        </th>
                                        <th class="py-2 px-3 text-center text-sm">
                                            Register
                                        </th>
                                        <th class="py-2 px-3 text-center text-sm">
                                            Tgl.Reg Masuk
                                        </th>
                                        <th class="py-2 px-3 text-center text-sm">
                                            Boleh Pulang
                                        </th>
                                        <th class="py-2 px-3 text-center text-sm">
                                            Farmasi
                                        </th>
                                        <th class="py-2 px-3 text-center text-sm">
                                            Close Bed
                                        </th>
                                        <th class="py-2 px-3 text-center text-sm">
                                            Tgl.Jam Boleh Pulang
                                        </th>
                                        <th class="py-2 px-3 text-center text-sm">
                                            Obat Pulang
                                        </th>
                                        <th class="py-2 px-3 text-center text-sm">
                                            Tgl.Jam Serah Obat
                                        </th>
                                        <th class="py-2 px-3 text-center text-sm">
                                            Status
                                        </th>
                                        <th class="py-2 px-3 text-center text-sm">
                                            Waktu Tunggu Plg
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="pasien in pasienPulangRanap.pasien"
                                        class="hover:bg-gray-100"
                                    >
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{ pasien.no }}
                                        </td>
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{pasien.nama_bed}}
                                        </td>
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{pasien.nama_pasien}}
                                        </td>
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{pasien.alamat_pasien}}
                                        </td>
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{pasien.register}}
                                        </td>
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{pasien.tgl_masuk_reg}}
                                        </td>
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer text-center">
                                            {{ pasien.boleh_pulang==1?"✅":"❌" }}
                                        </td>
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer text-center">
                                            {{ pasien.farmasi==1?"✅":"❌" }}
                                        </td>
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer text-center">
                                            {{ pasien.close_bed==1?"✅":"❌" }}
                                        </td>
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{(pasien.tgl_jam_boleh_pulang != ">>>>->>->> >>:>>:>>")?pasien.tgl_jam_boleh_pulang:""}}
                                        </td>
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer text-center">
                                            {{ pasien.is_resep_pulang==1?"✅":"❌" }}
                                        </td>
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                            {{ pasien.tgl_jam_serah_obat }}
                                        </td>
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        AKTIF
                                        </td>
                                        <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{ pasien.waktu_tunggu_pulang }}
                                        </td>
                                    </tr>
                                    <tr class="bg-white hover:bg-gray-200 focus-within:bg-gray-200" v-if="pasienPulangRanap.pasien.length === 0">
                                        <td class="border-r border-t text-sm select-none cursor-pointer" colspan="11">
                                            Belum ada data pasien
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdmin from "../../../Shared/LayoutAdmin.vue";
import LayoutAdminBig from "../../../Shared/LayoutAdminBig.vue";
import RandomShape from "../../../Shared/RandomShape.vue";
import DateInput from "../../../Shared/DateInput.vue";
import TextInput from "../../../Shared/TextInput.vue";
import SelectInput from "../../../Shared/SelectInput.vue";
export default {
    components: {
        Link,
        RandomShape,
        DateInput,
        TextInput,
        SelectInput
    },
    data() {
        return {
            pasienPulangRanapData: this.pasienPulangRanap.data,
            timerCount: 10,
            tglMasukBedData: this.tglMasukBed,
            statusData: this.status,
        };
    },
    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                } else {
                    this.getPasienPulangRanap();
                }
            },
            immediate: true,
        },
    },
    props: {
        pasienPulangRanap: Object,
        tglMasukBed: String,
        status: String,
    },
    methods: {
        getPasienPulangRanap() {
            this.$inertia.get(
                "/admin/pasien_pulang_ranap/ajax",
                {
                    tglMasukBed: this.tglMasukBedData,
                    status: this.statusData
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.timerCount = 10;
                        this.pasienPulangRanapData = page.props.additional.pasienPulangRanap.data;
                    },
                }
            );
        },
    },
    layout: LayoutAdminBig,
};
</script>
